export default class SubfieldsSequence {
    constructor(connections) {
        this.adj = this.normalizeGraph(connections);
        this.nodes = Object.keys(this.adj).map(Number);
    }

    normalizeGraph(raw) {
        const graph = {};
        for (let u in raw) {
            if (!graph[u]) graph[u] = new Set();
            for (let v of raw[u]) {
                graph[u].add(Number(v));
                if (!graph[v]) graph[v] = new Set();
                graph[v].add(Number(u));
            }
        }
        for (let u in graph) graph[u] = Array.from(graph[u]);
        return graph;
    }

    // Encuentra el camino simple más largo que termina en el destino
    findMainPath(destination) {
        let maxPath = [];

        const dfs = (current, path, visited) => {
            if (current === destination) {
                if (path.length > maxPath.length) maxPath = [...path];
                return;
            }

            for (let neighbor of this.adj[current]) {
                if (!visited.has(neighbor)) {
                    visited.add(neighbor);
                    dfs(neighbor, [...path, neighbor], visited);
                    visited.delete(neighbor);
                }
            }
        };

        this.nodes.forEach(n => {
            let v = new Set([n]);
            dfs(n, [n], v);
        });

        return maxPath;
    }

    // BFS para encontrar el camino más corto de tránsito
    shortPath(start, end) {
        if (start === end) return [];
        let queue = [[start, []]];
        let visited = new Set([start]);

        while (queue.length > 0) {
            let [curr, path] = queue.shift();
            for (let v of this.adj[curr]) {
                if (v === end) return [...path, v];
                if (!visited.has(v)) {
                    visited.add(v);
                    queue.push([v, [...path, v]]);
                }
            }
        }
        return [];
    }

    solve(exitId) {
        const P = this.findMainPath(exitId);
        const onMainPath = new Set(P);
        const worked = new Set();
        const sequence = [];

        // 1. Ir al inicio del camino principal (P[0]) desde la salida
        const outbound = this.shortPath(exitId, P[0]);
        sequence.push({ id: exitId, w: false });
        outbound.forEach(id => sequence.push({ id, w: false }));

        // 2. Recorrer el camino principal
        for (let i = 0; i < P.length; i++) {
            const current = P[i];

            // Ramificaciones laterales
            for (let neighbor of this.adj[current]) {
                if (!onMainPath.has(neighbor) && !worked.has(neighbor)) {
                    this.workBranch(neighbor, current, onMainPath, worked, sequence);
                }
            }

            // Trabajar el nodo actual del camino principal
            const last = sequence[sequence.length - 1];
            if (last.id === current) last.w = true;
            else sequence.push({ id: current, w: true });
            
            worked.add(current);

            // Moverse al siguiente nodo del camino (si existe)
            if (i < P.length - 1) {
                sequence.push({ id: P[i+1], w: false });
            }
        }

        // return sequence.map(s => `${s.id}${s.w ? '(w)' : ''}`).join(' -> ');
        return sequence;
    }

    workBranch(node, parent, main, worked, sequence) {
        sequence.push({ id: node, w: false });
        worked.add(node);

        for (let v of this.adj[node]) {
            if (!main.has(v) && !worked.has(v)) {
                this.workBranch(v, node, main, worked, sequence);
            }
        }
        
        const last = sequence[sequence.length - 1];
        if (last.id === node) last.w = true;
        else sequence.push({ id: node, w: true });

        sequence.push({ id: parent, w: false });
    }
}

/*

// --- TEST ACTUALIZADO (Base 0) ---
const connections = {
  '0': [ 1, 2, 3 ],
  '1': [ 0, 3 ],
  '2': [ 0 ],
  '3': [ 0, 1 ]
};

const optimizer = new SubfieldsSequence(connections);

// Ejecutamos el optimizador asumiendo que el punto de salida/entrada es el nodo 0
console.log("Optimized Sequence:", optimizer.solve(0));

*/